import classNames from "classnames/bind";
import { StoreStock } from "@/components/__shared__/StoreStock/StoreStock";
import { useState } from "react";
import { NotifiableEvent } from "@/types/types";

import styles from "./NotAvailable.module.scss";
import { Confirmation } from "./Confirmation/Confirmation";
import { NotifyMeForm } from "./NotifyMeForm/NotifyMeForm";

const cx = classNames.bind(styles);

const outOfStockMessage = "Currently out of stock online";

export type Props = {
  isFutureRelease: boolean;
  isInStoreOnly: boolean;
  isPreOrderable: boolean;
  isVariantSelected: boolean;
  stockApiBaseUrl: string;
  stockApiKey: string;
  storeStockApiKey: string;
  storeStockDisplayCode: string;
  storeStockModalApiUrl: string;
  storeStockScriptUrl: string;
  storeStockSkuId: string;
  storeStockTitle: string;
  pimProductId: string;
  notifiableEventType?: NotifiableEvent;
  notificationsApiBaseUrl: string;
  notificationsApiKey: string;
  showOutOfStockExperienceInfo: boolean;
  showNotAvailableInTwoCols?: boolean;
};

export const NotAvailableUI = ({
  isFutureRelease,
  isInStoreOnly,
  isPreOrderable,
  isVariantSelected,
  stockApiBaseUrl,
  stockApiKey,
  storeStockApiKey,
  storeStockDisplayCode,
  storeStockModalApiUrl,
  storeStockScriptUrl,
  storeStockSkuId,
  storeStockTitle,
  pimProductId,
  notifiableEventType,
  notificationsApiBaseUrl,
  notificationsApiKey,
  showOutOfStockExperienceInfo,
  showNotAvailableInTwoCols,
}: Props) => {
  const [notificationSent, setNotificationSent] = useState(false);
  const showNotAvailableContent =
    notifiableEventType !== undefined || showOutOfStockExperienceInfo;

  if (isInStoreOnly) {
    return (
      <StoreStock
        title={storeStockTitle}
        displayCode={storeStockDisplayCode}
        skuId={storeStockSkuId}
        isPreOrderable={isPreOrderable}
        isFutureRelease={isFutureRelease}
        usePrimaryButton={true}
        storeStockScriptUrl={storeStockScriptUrl}
        stockApiKey={stockApiKey}
        stockApiBaseUrl={stockApiBaseUrl}
        storeStockApiKey={storeStockApiKey}
        storeStockModalApiUrl={storeStockModalApiUrl}
        isVariantSelected={isVariantSelected}
      />
    );
  }

  if (!showNotAvailableContent) {
    return null;
  }

  return (
    <div
      className={cx(styles.wrapper, [
        { isOosHowToGetIt: showNotAvailableInTwoCols },
      ])}
    >
      {!showNotAvailableInTwoCols && showOutOfStockExperienceInfo && (
        <div
          data-testid="product:basket:out-of-stock-experience"
          className={cx(styles.outOfStockExperienceInfoWrapper, {
            inStoreOnly: isInStoreOnly,
          })}
        >
          <h2
            className={styles.outOfStockMessage}
            data-testid="product:tools:store-stock:checkInStoreHeader"
          >
            {outOfStockMessage}
          </h2>
          <StoreStock
            title={storeStockTitle}
            displayCode={storeStockDisplayCode}
            skuId={storeStockSkuId}
            isPreOrderable={isPreOrderable}
            isFutureRelease={isFutureRelease}
            usePrimaryButton={true}
            storeStockScriptUrl={storeStockScriptUrl}
            stockApiKey={stockApiKey}
            stockApiBaseUrl={stockApiBaseUrl}
            storeStockApiKey={storeStockApiKey}
            storeStockModalApiUrl={storeStockModalApiUrl}
            isVariantSelected={isVariantSelected}
          />
          <div
            id="store-stock-error-wrapper"
            data-testid="product:tools:store-stock:error"
          />
        </div>
      )}

      <>
        {notificationSent ? (
          <Confirmation />
        ) : (
          <NotifyMeForm
            pimProductId={pimProductId}
            skuId={storeStockSkuId}
            onSuccess={() => setNotificationSent(true)}
            notifiableEventType={notifiableEventType}
            notificationsApiBaseUrl={notificationsApiBaseUrl}
            notificationsApiKey={notificationsApiKey}
            isSelected={isVariantSelected}
          />
        )}
      </>
    </div>
  );
};
